/**
 * Duplicate this file,
 * then change its name into `apollo.config.js`.
 */
const isProduction = process.env.NODE_ENV === 'production';

const configs = {
  dev: {
    uri: 'http://localhost:60000/simple/v1/cjclighsd00040167ugjwbzga', // Mine is: 'http://localhost:60000/simple/v1/cjbeszs0u00020127v5x15uuc'
  },
  prod: {
    uri: 'https://api.graph.cool/simple/v1/cjchrketi1sv80168snuj7ckr',
  },
};

export default isProduction ? configs.prod : configs.dev;



//////////////////
// WEBPACK FOOTER
// ./config/apollo.config.js
// module id = null
// module chunks = 